export default __webpack_public_path__ + "static/media/SWT1370.34I-34999_-24499_0.ae287e03.jpg";